import { motion, AnimatePresence } from 'framer-motion';
import { useState } from 'react';
import cn from 'classnames';
import { ExpandLessIcon } from '@/components/icons/expand-less-icon';
import { ExpandMoreIcon } from '@/components/icons/expand-more-icon';

export const CustomCollapse = ({
  keepExpanded,
  initialValue,
  children,
  className,
  name,
  icon,
}: {
  children: React.ReactNode;
  minChildrenHeight?: number;
  initialValue?: boolean;
  keepExpanded?: boolean;
  className?: string;
  name: string;
  icon?: string;
}) => {
  const [isOpen, setIsOpen] = useState(initialValue ?? keepExpanded);
  const toggleCollapse = () => {
    if (keepExpanded) return;

    setIsOpen(!isOpen);
  };

  return (
    <>
      <button type="button"
        onClick={toggleCollapse}
        className={cn(
          'flex w-full items-center py-3 font-semibold text-body-dark outline-none transition-all ease-in-expo  focus:text-accent focus:outline-0 focus:ring-0 ltr:text-left rtl:text-right',
          isOpen ? 'text-accent' : 'text-body-dark',
          className ? className : 'text-sm',
        )}
      >
        <span>{name}</span>
        {!keepExpanded && (
          <span className="ltr:ml-auto ltr:mr-4 rtl:ml-4 rtl:mr-auto">
            {!isOpen ? (
              <ExpandLessIcon className="h-3 w-3" />
            ) : (
              <ExpandMoreIcon className="h-3 w-3" />
            )}
          </span>
        )}
      </button>
      {isOpen && children}
    </>
  );
};

export const AnimatedCollapseContainer = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  return (
    <AnimatePresence>
      <motion.div
        key="content"
        initial="collapsed"
        animate="open"
        exit="collapsed"
        variants={{
          open: { opacity: 1, height: 'auto' },
          collapsed: { opacity: 0, height: 0 },
        }}
        transition={{ duration: 0.5, ease: [0.04, 0.62, 0.23, 0.98] }}
        className="text-xs ltr:pl-4 rtl:pr-4 bg-white"
      >
        {children}
      </motion.div>
    </AnimatePresence>
  );
};
